angular.module('app').factory('DynamicSimService', function(HttpHelper, $browser) {
    var fac = {};
    var api = 'api/DynamicSim/';
    fac.getXml = function(userId) {
        return HttpHelper.get([api, 'getXml?UserId=', userId].join(''));
    };
    fac.saveXml = function(userId, xml) {
        return HttpHelper.post([api, 'saveXml'].join(''), { UserId: userId, Xml: xml });
    };
    return fac;
});